import JsonLd from '@/components/base/JsonLd';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://hipobuyspread.org';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg';

interface ArticleSchemaProps {
  slug: string;
  title: string;
  description: string;
  imageUrl: string;
  datePublished?: string;
  dateModified?: string;
}

export default function ArticleSchema({
  slug,
  title,
  description,
  imageUrl,
  datePublished = '2026-07-09',
  dateModified = '2026-07-09',
}: ArticleSchemaProps) {
  const pageUrl = `${siteUrl}/${slug}`;

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    '@id': `${pageUrl}/#article`,
    headline: title,
    description,
    image: {
      '@type': 'ImageObject',
      url: imageUrl,
    },
    author: {
      '@type': 'Organization',
      name: 'Hipobuy Editorial Team',
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Hipobuy Spreadsheet',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
        width: 512,
        height: 512,
      },
    },
    datePublished,
    dateModified,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: title,
        item: pageUrl,
      },
    ],
  };

  return (
    <>
      <JsonLd data={articleSchema} />
      <JsonLd data={breadcrumbSchema} />
    </>
  );
}